import {
    Box,
    SpaceBetween,
} from '@amzn/awsui-components-react';

import { AttachmentFile } from 'common';
import { PendingAttachmentFile } from 'common/AttachmentFile/PendingAttachmentFile';
import { Attachment } from '@amzn/ito-client';

interface OrderAttachmentsProps {
    attachments?: Attachment[],
    error: Error | undefined,
    pendingFiles?: File[],
    onDismissPendingFile?: (index: number) => void,
}

export const OrderAttachments = (props: OrderAttachmentsProps) => {
    
    const displayAttachments = (): JSX.Element | JSX.Element[] => {
        const elements: JSX.Element[] = [];

        if (props.attachments && props.attachments.length > 0) {
            props.attachments.forEach((attachment, id) => {
                elements.push(<AttachmentFile key={`existing-${id}`} attachment={attachment} />);
            });
        }

        if (props.pendingFiles && props.pendingFiles.length > 0 && props.onDismissPendingFile) {
            props.pendingFiles.forEach((file, index) => {
                elements.push(
                    <PendingAttachmentFile
                        key={`pending-${index}`}
                        file={file}
                        onDismiss={() => props.onDismissPendingFile!(index)}
                    />
                );
            });
        }

        if (elements.length === 0) {
            return <Box color="text-status-inactive">No attachments</Box>;
        }

        return elements;
    }

    return (
        <SpaceBetween size="m" direction="horizontal">
            {displayAttachments()}
        </SpaceBetween>
    )
};
